export function localStoragePlugin () {
  return function (store) {
    store.subscribe(function (mutation, state) {
      if (mutation.type === 'twilio/changeMediaDevice') {
        saveToLocalStorage('lc-media-opts', state.twilio.mediaOpts)
        saveToSessionStorage('lc-media-opts', state.twilio.mediaOpts)
      }
    })
  }
}

export function getFromLocalStorage (key) {
  return JSON.parse(window.localStorage.getItem(key))
}

export function saveToLocalStorage (key, payload) {
  return window.localStorage.setItem(key, JSON.stringify(payload))
}

export function removeFromLocalStorage (key) {
  return window.localStorage.removeItem(key)
}

export function getFromSessionStorage (key) {
  return JSON.parse(window.sessionStorage.getItem(key))
}

export function saveToSessionStorage (key, payload) {
  return window.sessionStorage.setItem(key, JSON.stringify(payload))
}

export function removeFromSessionStorage (key) {
  return window.sessionStorage.removeItem(key)
}

export function storageKey (channel, classIdentifier) {
  if (!classIdentifier) {
    throw Object.assign(new Error('no class idetifier for local storage'))
  }
  return `lc-class-${classIdentifier}-${channel}`
}
